import { createImagesClient } from '../trpc/images-image-user-profile';

/** INF-102 registry. Population and URL activation require separate rollout approval.
 * IDs are persisted CharityStack organization IDs, never Clerk IDs or merchant names.
 * No PostHog cache, browser storage, wildcard, or implicit global enablement.
 */
export const imagesRollout = Object.freeze({
  key: 'org_engagement_admin_api_cutover_images',
  organizations: Object.freeze([] as readonly { organizationId: string; enabled: boolean }[]),
});

export function selectImagesClient({
  organizationId,
  authorization,
  registry = imagesRollout.organizations,
  url = import.meta.env.VITE_APP_ORG_ENGAGEMENT_TRPC_URL,
}: {
  organizationId: unknown;
  authorization: string;
  registry?: unknown;
  url?: unknown;
}) {
  try {
    if (typeof organizationId !== 'string' || !organizationId || !Array.isArray(registry))
      return null;
    const seen = new Set<string>();
    let enabled = false;
    for (const row of registry) {
      if (
        !row ||
        typeof row !== 'object' ||
        Object.keys(row).sort().join(',') !== 'enabled,organizationId' ||
        typeof row.organizationId !== 'string' ||
        !row.organizationId ||
        typeof row.enabled !== 'boolean' ||
        seen.has(row.organizationId)
      )
        return null;
      seen.add(row.organizationId);
      if (row.organizationId === organizationId) enabled = row.enabled;
    }
    if (!enabled || typeof url !== 'string' || !url || !authorization) return null;
    const parsed = new URL(url);
    if (
      parsed.protocol !== 'https:' ||
      parsed.username ||
      parsed.password ||
      parsed.search ||
      parsed.hash
    )
      return null;
    return createImagesClient({ url, authorization });
  } catch {
    // Unreadable or ambiguous configuration retains the known legacy path.
    return null;
  }
}
